import script from "./DefDarkenBackground.vue?vue&type=script&lang=js"
export * from "./DefDarkenBackground.vue?vue&type=script&lang=js"

import "./DefDarkenBackground.vue?vue&type=style&index=0&id=17b58bee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17b58bee"]])

export default __exports__